module.exports = __webpack_public_path__ + "static/campbell-b362dcc34309d578861927a9d992c39d.jpg";